import { createDecorator } from '../../instantiation/common/instantiation.js';

const ILabelService = createDecorator('labelService');

export { ILabelService };
